var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      class: { "has-variations": _vm.ordine.numeroVariazioniNonRilevate > 0 },
      attrs: { hover: "" },
      nativeOn: {
        click: function ($event) {
          return _vm.showDetail()
        },
      },
    },
    [
      _c(
        "v-avatar",
        { staticClass: "ico-stato", attrs: { size: "40" } },
        [
          _c(
            "v-icon",
            {
              class: [
                _vm.iconClassByStatus(_vm.ordine),
                "lighten-1",
                "white--text",
              ],
            },
            [_vm._v(_vm._s(_vm._f("statoOrdineMTMIco")(_vm.ordine.stato)))]
          ),
        ],
        1
      ),
      _c("v-card-text", [
        _c("h3", { staticClass: "headline mb-0" }, [
          _vm._v("Num. " + _vm._s(_vm.ordine.id)),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("DATA CONSEGNA: "),
          _c("strong", [
            _vm._v(_vm._s(_vm._f("formatDate")(_vm.ordine.dataConsegna))),
          ]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("PRIORITA': "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.priorita))]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("CLIENTE: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.nominativoCliente))]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("CODICE ZONA: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.codiceZona))]),
        ]),
      ]),
      _c("v-card-text", [
        _c("div", [
          _vm._v("Numero righe: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.numeroRighe))]),
        ]),
        _c("div", [
          _vm._v("Numero misure: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.numeroMisure))]),
        ]),
        _c("div", [
          _vm._v("Numero misure cliente: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.numeroMisureCliente))]),
        ]),
        _c("div", [
          _vm._v("Numero allegati: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.numeroAllegati))]),
        ]),
        _c("div", [
          _vm._v("Numero allegati cliente: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.numeroAllegatiCliente))]),
        ]),
        _vm.ordine.numeroVariazioniNonRilevate == 1
          ? _c("div", { staticStyle: { color: "#3f8fd0" } }, [
              _vm._v("E' presente "),
              _c("strong", [
                _vm._v(_vm._s(_vm.ordine.numeroVariazioniNonRilevate)),
              ]),
              _vm._v(" variazione non rilevata."),
            ])
          : _vm._e(),
        _vm.ordine.numeroVariazioniNonRilevate > 1
          ? _c("div", { staticStyle: { color: "#3f8fd0" } }, [
              _vm._v("Sono presenti "),
              _c("strong", [
                _vm._v(_vm._s(_vm.ordine.numeroVariazioniNonRilevate)),
              ]),
              _vm._v(" variazioni non rilevate."),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }